import {
  NameColumnDef,
  EditDeleteColumnDef,
  EmailColumnDef,
  AddressColumnDef,
  CityColumnDef,
  CountryColumnDef,
  StateColumnDef,
  ZipcodeColumnDef,
  PhoneColumnDef,
  ContactColumnDef,
} from "components/AGTable/NewColumns/ColumnDefinition";

const defaultColDef = {
  sortable: true,
  resizable: true,
  cellClass: "no-border",
  cellStyle: { display: "flex", "justify-content": "center" },
  filter: true,
};

export const carrierGrid = {
  columnDefs: [
    EditDeleteColumnDef,
    // CarriersWarehousesDetails, Not required for phase1, should be revisited and fixed in phase2
    NameColumnDef,
    AddressColumnDef,
    CityColumnDef,
    StateColumnDef,
    CountryColumnDef,
    ZipcodeColumnDef("zipcode"),
    PhoneColumnDef,
    EmailColumnDef,
    ContactColumnDef,
  ],
  defaultColDef,
};
